// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fai-invite-system[data-v-6fc14f9c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: baseline;\n      -ms-flex-align: baseline;\n          align-items: baseline;\n}\n.fai-invite-system__select[data-v-6fc14f9c] {\n  width: 100px;\n  margin-left: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
